import React from 'react';
import styled from 'styled-components';
import useMediaQuery from '@mui/material/useMediaQuery';

import Edges from './Edges';
import logo from '../images/bcit_logo.svg';

import * as theme from '../theme';

import VideoPlayer from './VideoPlayer';
import {logUserAction} from "../services/appServices";
import UserActions from "../constants/user-actions";

const Footer = () => {
    const isDesktop = useMediaQuery('(min-width:768px)');
    const date = new Date();
    const year = date.getFullYear();
    const [tutorialOpen, setTutorialOpen] = React.useState(false);

    const handleTutorialToggle = () => {
        setTutorialOpen(!tutorialOpen);
        logUserAction(UserActions.VIDEOTUTORIAL);
    };

    return (
        <Container>
            <Top size="md">
                <a href="https://www.bcit.ca/" target="_blank" rel="BCIT">
                    <img src={logo} alt="BCIT Logo" style={{ height: 50, width: 50, margin: 0 }} />
                </a>
                {isDesktop && (
                    <a href="https://timetablesadmin.bcit.ca/" target="_blank" rel="noopener noreferrer">
                        Instructor Office Hours
                    </a>
                )}
                <a href="https://www.bcit.ca/business/" target="_blank" rel="noopener noreferrer">
                    School of Business
                </a>
                <a onClick={handleTutorialToggle}>Tutorial</a>
                <a href="https://www.bcit.ca/privacy/" target="_blank" rel="noopener noreferrer">
                    Privacy Policy
                </a>
                <a href="mailto:ttportal@bcit.ca">
                    Technical Support
                </a>
            </Top>
            <BottomContainer>
                <Bottom size="md">
                    <div>© {year} BCIT. All rights reserved.</div>
                </Bottom>
            </BottomContainer>
            <VideoPlayer open={tutorialOpen} close={handleTutorialToggle} />
        </Container>
    );
};

const Container = styled.div`
    border-top: 1px solid #eaeaea;
    background: #fff;
    width: 100%;
    box-shadow: 0 0px 20px 1px rgba(0, 0, 0, 0.1);
`;

const Top = styled(Edges)`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    flex-wrap: wrap;
    padding: 10px 0;

    a {
        cursor: pointer;
        text-decoration: none;
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 10px 0;
        color: #333;
        margin: 0 10px;
        font-size: 14px;
        text-align: center;
        &:hover {
            color: ${theme.colors.primary};
        }
    }
    @media (min-width: 640px) {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        flex-wrap: wrap;
        padding: 20px 0;
    }
`;

const BottomContainer = styled.div`
    background: #163761;
    padding: 20px 0;
    display: flex;
    justify-content: center;
    align-items: center;
`;

const Bottom = styled(Edges)`
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
    font-size: 14px;
    color: #f6f8fb;

    > div {
        text-align: center;
        width: 100%;
        margin: 5px 0;
        @media (min-width: 640px) {
            text-align: center;
            width: auto;
        }
    }

    a {
        color: #f6f8fb;
        margin: 0 4px;
    }
`;

export default Footer;
